#login-page {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

#concourse-logo {
  margin-bottom: 20px;
}

#login-page ion-card {
  display: block;
  height: fit-content; 
  width: 100%;
  max-width: 400px;
  border-radius: 12px;
  --background: var(--ion-color-step-900);
}

#login-page ion-card-title {
  text-align: center;
  padding: 16px 0px 16px 0px;
}

ion-button#login-submit {
  margin: 12px 0px 12px 0px;
}

.terms-paragraph {
  max-width: 80%;
  font-size: 12px;
}

ion-card#forgot-password {
  --background: var(--ion-color-step-900);
}

#forgot-password ion-card-header {
  padding: 16px 16px 5px 16px;
}

.close-icon {
  cursor: pointer;
  font-size: 24px;
}

.close-icon:hover {
  color: var(--color-primary-2);
  text-decoration: underline;
}

.forgot-password-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 26px 14px 26px;
}

.forgot-password-content ion-button{
  margin: 18px 0px 14px 0px;  
}

@media screen and (min-width: 568px) {
  #login-page ion-card, .terms-paragraph {
    max-width: 468px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    margin-left: auto;
    margin-right: auto;
  }
  .terms-paragraph{
    max-width: 368px;
    font-size: smaller;
  }
  .forgot-password-modal {
    --max-width: 508px;
  }
  
}

.login-footer {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 12px;
  color: var(--ion-color-step-600);
  width: 100%;
  padding: 0 20px;
}

.login-footer span {
  display: inline-block;
}

.login-footer .footer-link {
  color: var(--ion-color-step-600);
  text-decoration: underline;
  cursor: pointer;
}

.login-footer .footer-link:hover {
  color: var(--ion-color-primary);
}
